import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutoLoginClient } from 'app/auth/auto-login.client';
import { AuthClient } from 'app/auth/auth.client';
import { BzgToastService } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { OverlayService } from 'app/shared/services/overlay.service';
import { HttpXsrfTokenExtractor } from "@angular/common/http";


@Component({
    selector: 'adminlogin',
    templateUrl: 'admin-login.component.html',
    styleUrls: ['admin-login.component.scss']
})
export class AdminLoginComponent {
    public userName = '';
    public password = '';
    public rememberMe: boolean;

    constructor(private _router: Router,
        private _autoLoginClient: AutoLoginClient,
        private _authClient: AuthClient,
        private _toastService: BzgToastService,
        private _translateService: TranslateService,
        private _overlayService: OverlayService,
        private _tokenExtractor: HttpXsrfTokenExtractor) { }

    ngAfterViewInit() {
      this._overlayService.hide();
    }

    public login() {
        const XSRFtoken = this._tokenExtractor.getToken() as string;
        $.ajaxSetup({
            beforeSend(xhr) {
                xhr.setRequestHeader('X-XSRF-TOKEN', XSRFtoken);
            }
        });
        if (this.userName.length > 0 && this.password.length > 0) {
            this._autoLoginClient.login(this.userName, this.password).subscribe((data: any) => {
                switch (data.autoLoginCodeMessage) {
                    case 'LoginUserMustChangePassword':
                        this._router.navigate(['email-sent']);
                        break;
                    case 'LoginSucessful':
                        sessionStorage.setItem('timeExpiration', data.sessionTimeout);
                        this._authClient.setAuthenticationSubject(true);
                        this._router.navigate(['mc']);
                        break;
                    case 'LoginUserNotVerified':
                        this._translateService.get('AUTOADMIN.USER_NOT_VERIFIED').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    case 'LoginUserInactive':
                        this._translateService.get('AUTOADMIN.USER_INACTIVE').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    case "LoginLockedAccount":
                        this._translateService.get('AUTOADMIN.LOCKED_ACCOUNT').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: "error",
                                    duration: 0,
                                    verticalPosition: "bottom",
                                    horizontalPosition: "right"
                                });
                        });
                        break;           
                    case 'LoginWrongCredentials':
                        this._translateService.get('AUTOADMIN.WRONG_CREDENTIALS').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    case 'SendVerificationCodeUnexpectedError':
                    case 'SendVerificationCodeMissingSMTPConfiguration':
                        this._translateService.get('AUTOADMIN.SEND_EMAIL_UNEXPECTED_ERROR').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    case 'LoginUnexpectedError':
                        this._translateService.get('GLOBAL.GENERIC_ERROR_MSG').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;

                    case 'SendVerificationCodeSMTPWrongConfiguration':
                        this._translateService.get('AUTOADMIN.SEND_EMAIL_WRONG_CONFIGURATION').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;

                    default:
                        break;
                }

            });
        }
    }


    public restorePassword() {
        this._router.navigate(['send-password-email']);
    }
}
